import { createAction, props } from '@ngrx/store';
import { StatementsPanelFilters } from '../states/statements.state';

export const STATEMENTS_SET_PANEL_FILTERS =
  '[STATEMENTS] Set statements filters';

export const setPanelFilters = createAction(
  STATEMENTS_SET_PANEL_FILTERS,
  props<{ panelFilters: StatementsPanelFilters }>()
);
